import { render, staticRenderFns } from "./TVD.vue?vue&type=template&id=4071c918&scoped=true&"
import script from "./TVD.vue?vue&type=script&lang=js&"
export * from "./TVD.vue?vue&type=script&lang=js&"
import style0 from "./TVD.vue?vue&type=style&index=0&id=4071c918&scoped=true&lang=css&"
import style1 from "./TVD.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4071c918",
  null
  
)

export default component.exports